<template>
  <section class="relative bg-blue-100">
    <div class="max-w-[1920px] p-4 md:px-[60px] lg:px-8 xl:px-[80px] 2xl:px-[120px] mx-auto">
      <div>
        <div class="hidden md:block w-[340px] h-[340px] left-[-180px] top-[80px] rounded-full bg-white absolute z-0" />
        <div class="hidden md:block w-[340px] h-[340px] left-[-20px] top-[-80px] rounded-full bg-white absolute z-0" />
        <div class="md:hidden block w-[180px] h-[180px] left-[-90px] top-[20px] rounded-full bg-white absolute z-0" />
        <div class="md:hidden block w-[180px] h-[180px] left-[0px] top-[-80px] rounded-full bg-white absolute z-0" />

        <div class="hidden md:block w-[340px] h-[340px] right-[-100px] bottom-[-20px] rounded-full bg-white absolute z-0 " />
        <div class="hidden md:block w-[340px] h-[340px] right-[60px] bottom-[-160px] rounded-full bg-white absolute z-0" />
        <div class="md:hidden block w-[180px] h-[180px] right-[-80px] bottom-[0px] rounded-full bg-white absolute z-0 " />
        <div class="md:hidden block w-[180px] h-[180px] right-[0px] bottom-[-100px] rounded-full bg-white absolute z-0" />
      </div>

      <div class="py-[80px] lg:py-[140px] z-10 relative">
        <h2 class="text-[40px] leading-[52px] lg:text-[50px] xl:text-[56px] text-black font-semibold mb-3 md:mb-4">{{ t('home.team.title') }}</h2>

        <div class="block lg:flex space-x-0 space-y-[32px] lg:space-y-0 lg:space-x-[24px] xl:space-x-[44px]">
          <div class="rounded-3xl lg:w-[320px] 2xl:w-[440px] space-y-[32px] lg:space-y-0 flex-grow-0 flex-shrink-0 flex flex-col justify-self-center lg:justify-self-start lg:justify-between bg-white p-6">
            <div>
              <button class="py-2.5 px-5 border border-solid border-blue-600 text-[24px] text-blue-600 font-medium  rounded-full leading-none">
                TEAM
              </button>
            </div>
            <div class="flex justify-center space-x-[-30px]">
              <img class="w-auto h-[77px] md:w-auto md:h-[100px] rounded-full border-[6px] border-blue-100" src="/images/team-member-sm1.png" alt="member3">
              <img class="w-auto h-[77px] md:w-auto md:h-[100px] rounded-full border-[6px] border-blue-100" src="/images/team-member-sm2.png" alt="member2">
              <img class="w-auto h-[77px] md:w-auto md:h-[100px] rounded-full border-[6px] border-blue-100" src="/images/team-member-sm3.png" alt="member1">
            </div>
            <div class="flex items-center justify-between space-x-4">
              <div class="text-[22px] 2xl:text-[32px] leading-none font-[400] ">
                {{ t('home.team.subtitle') }}
              </div>
              <VaButton
                class="!w-[116px] disable-min-w"
                color="blue-500"
                round
                :to="{ name: 'team' }"
              >
                <span class=" px-1 xl:px-[34px]"><Frama /></span>
              </VaButton>
            </div>
          </div>
          <div class="rounded-3xl flex flex-col lg:flex-row items-center py-4 px-6 space-x-0 lg:space-x-[20px] 2xl:space-x-[48px] bg-green-100">
            <img src="@/assets/images/team.webp" alt="junior-member" class="mb-[28px] lg:w-[300px] lg:mb-0 w-[350px] 2xl:w-full h-full rounded-[48px] basis-1 grow">
            <div class="lg:space-y-4 md:space-y-3 pr-4 basis-1 grow">
              <p class="text-[18px] md:[22px] font-medium text-black leading-[26px] lg:leading-[28px] xl:leading-[34px]">
                {{ t('team.team.text') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import Frama from '@/assets/icons/menu/frama.svg'
import { VaButton } from 'vuestic-ui'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>
